export type GetOrgCheckState = {
    getOrgCheckLoading: boolean;
    getOrgCheckSuccess: boolean;
    loading: boolean;
    success: boolean;
};
export const initialGetOrgCheckState: GetOrgCheckState = {
    getOrgCheckLoading: false,
    getOrgCheckSuccess: false,
    loading: false,
    success: false,
};
